export default __webpack_public_path__ + "static/media/view_on_github.ca022a11.png";